import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core'
import {ToastService} from '../../services/toast.service'
import {LangService} from "../../services/lang.service";

interface Article {
    slug: string;
    title: string;
    categoryTitle: string;
}

@Component({
    selector: 'app-block-discover-articles',
    templateUrl: './block-discover-articles.component.html',
    styleUrls: ['./block-discover-articles.component.scss'],
    standalone: false
})
export class BlockDiscoverArticlesComponent implements OnInit {
    @Input() articles: Article[] = [];
    @Input() articleId: any;
    @Input() langTitle: any = 'block.related_articles.title';
    constructor(
        public toastService: ToastService,
        public lang: LangService
    ) {
    }
    ngOnInit() {}
}
